/* eslint-disable max-len */
import {
  Badge,
  Table,
  Tag,
  Typography,
} from 'antd';
import React, { useState } from 'react';
import CandidateModal from './CandidatosModal';

// eslint-disable-next-line no-unused-vars
const { Title } = Typography;

// 👇 Simula que importas tus datos reales
const candidatesData = [
  {
    email: 'carlos.méndez@ejemplo.com',
    telefono: '555-000-1001',
    estatus: 'Citado(a)',
    fuenteReclutamiento: 'LinkedIn',
    experiencia: '5 años',
    fechaAplicacion: '18/04/2023',
    cvURL: 'https://example.com/cv/carlos-méndez.pdf',
    escolaridad: 'Licenciatura en Sistemas Computacionales',
    institucion: 'Universidad Nacional Autónoma de México',
    anioGraduacion: '2018',
    idiomas: ['Inglés (Avanzado)', 'Español (Nativo)'],
    certificaciones: ['Scrum Master', 'React Developer Certificate'],
    habilidadesTecnicas: ['JavaScript', 'React', 'Node.js', 'CSS', 'HTML'],
    vacanteCodigo: 'PL001',
    vacantePlaza: 'Desarrollador Frontend',
    vacantePuesto: 'Desarrollador Senior',
    vacanteTipoEmpleado: 'Tiempo Completo',
    vacanteOficio: 'TEC-2023-045',
    vacanteMotivo: 'Crecimiento del equipo',
    vacanteEstatus: 'En Reclutamiento',
    vacantePruebas: ['Técnica Frontend', 'Psicométrica General'],
    solicitanteFolio: 'SOL-2023-001',
    solicitanteNombre: 'Juan Pérez Rodríguez',
    solicitantePuesto: 'Gerente de Desarrollo',
    solicitanteAreaCodigo: 'A001',
    solicitanteAreaNombre: 'Tecnología',
    id: 1,
    nombre: 'Carlos Méndez',
  },
];

const AplicacionDePruebas = () => {
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCandidateClick = (record) => {
    setSelectedCandidate(record);
    setIsModalOpen(true);
  };

  const columns = [
    {
      title: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
    },
    {
      title: 'Correo',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Vacante',
      dataIndex: 'vacantePlaza',
      key: 'vacantePlaza',
    },
    {
      title: 'Estado',
      dataIndex: 'estatus',
      key: 'estatus',
      render: (status) => <Badge status="processing" text={status} />,
    },
    {
      title: 'Pruebas Asignadas',
      dataIndex: 'vacantePruebas',
      key: 'vacantePruebas',
      render: (pruebas) => pruebas.map((p) => <Tag key={p}>{p}</Tag>),
    },
  ];
  return (
    <div>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={candidatesData}
        onRow={(record) => ({
          onClick: () => handleCandidateClick(record),
        })}
        pagination={false}
        className="rounded-md overflow-hidden"
      />

      <CandidateModal
        candidate={selectedCandidate}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default AplicacionDePruebas;
